import { render, staticRenderFns } from "./wage-accounting.vue?vue&type=template&id=6cb1bc2d&"
import script from "./wage-accounting.vue?vue&type=script&lang=ts&"
export * from "./wage-accounting.vue?vue&type=script&lang=ts&"
import style0 from "./wage-accounting.vue?vue&type=style&index=0&id=6cb1bc2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports